export default "__VITE_ASSET__BvT3D1xx__"